const pageNameKey = "overwriteStructureWarningModal";

export const overwriteStructureWarningModalEn = {
  [pageNameKey]: {
    subTitle: "Are you sure?",
    title: "Overwrite Structure",
    description:
      "Do you really want to transfer? All nodes will be overwritten by your current selection!",
    transferButton: "Transfer configuration",
    abortButton: "Abort",
  },
};

export const overwriteStructureWarningModalPtBr = {
  [pageNameKey]: {
    subTitle: "Tem certeza?",
    title: "Substituir estrutura",
    description:
      "Você realmente deseja transferir? Todos os nós serão substituídos pela sua seleção atual!",
    transferButton: "Configuração de transferência",
    abortButton: "Cancelar",
  },
};

export const overwriteStructureWarningModalDe = {
  [pageNameKey]: {
    subTitle: "Sind Sie sicher?",
    title: "Struktur überschreiben",
    description:
      "Möchten Sie wirklich übertragen? Alle Knoten werden durch Ihre aktuelle Auswahl überschrieben!",
    transferButton: "Konfiguration übertragen",
    abortButton: "Abbrechen",
  },
};

export const overwriteStructureWarningModalZhHans = {
  [pageNameKey]: {
    subTitle: "您确定吗？",
    title: "覆盖结构",
    description: "您真的要传输吗？所有节点将被您当前的选择覆盖！",
    transferButton: "传输配置",
    abortButton: "中止",
  },
};

export const overwriteStructureWarningModalIt = {
  [pageNameKey]: {
    subTitle: "Sei sicuro?",
    title: "Sovrascrivi struttura",
    description:
      "Vuoi davvero trasferire i dati? Tutti i nodi verranno sovrascritti dalla tua selezione attuale!",
    transferButton: "Trasferisci configurazione",
    abortButton: "Annulla",
  },
};

export const overwriteStructureWarningModalEs = {
  [pageNameKey]: {
    subTitle: "¿Estás seguro?",
    title: "Sobrescribir estructura",
    description:
      "¿De verdad quieres transferir? ¡Todos los nodos se sobrescribirán con tu selección actual!",
    transferButton: "Configuración de transferencia",
    abortButton: "Cancelar",
  },
};

export const overwriteStructureWarningModalNl = {
  [pageNameKey]: {
    abortButton: "Annuleren",
    description:
      "Wilt u echt overdragen? Alle nodes worden overschreven door uw huidige selectie!",
    subTitle: "Weet u het zeker?",
    title: "Structuur overschrijven",
    transferButton: "Configuratie overdragen",
  },
};

export const overwriteStructureWarningModalTr = {
  [pageNameKey]: {
    abortButton: "İptal et",
    description:
      "Gerçekten transfer olmak istiyor musun? Mevcut seçiminiz tüm düğümlerin üzerine yazılacaktır!",
    subTitle: "Emin misin?",
    title: "Yapının Üzerine Yaz",
    transferButton: "Aktarım yapılandırması",
  },
};
